module.exports = __webpack_public_path__ + "img/icon (23).3c690113.png";